import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './MobileHeader.css';
import { useState, useRef, useEffect } from 'react';

export default function MobileHeader(){
  const nav = useNavigate();
  const location = useLocation();
  const { accessToken, user, logout } = useAuth();
  const token = accessToken;
  
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  const initials = (() => {
    const name = user?.displayName || (user?.firstName && user?.lastName ? `${user.firstName} ${user.lastName}` : user?.email || '');
    if(!name) return 'DH';
    const parts = name.trim().split(/\s+/);
    if(parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
    return name.slice(0,2).toUpperCase();
  })();

  const avatarColor = (() => {
    const s = (user?.email || user?.displayName || 'docuhounds');
    let h = 0;
    for(let i=0;i<s.length;i++) h = (h<<5) - h + s.charCodeAt(i);
    const hue = Math.abs(h) % 360;
    return `hsl(${hue} 65% 45%)`;
  })();

  // Determine whether we're on the mobile splash
  const isMobileSplash = location.pathname === '/m' || location.pathname === '/m/';
  const compact = !token && isMobileSplash;

  const handleLogout = async ()=>{
    setMenuOpen(false);
    try{
      if (logout) await logout();
    } catch(e){}
    nav('/');
  };

  // close menu on outside click
  useEffect(()=>{
    const onDoc = (e)=>{
      if(menuRef.current && !menuRef.current.contains(e.target)) setMenuOpen(false);
    };
    document.addEventListener('click', onDoc);
    return ()=> document.removeEventListener('click', onDoc);
  },[]);

  // Listen for one-time shimmer trigger from landing page
  useEffect(() => {
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return;
    const handler = () => {
      const el = document.getElementById('mobile-header-signup');
      if (!el) return;
      el.classList.add('shimmer');
      window.setTimeout(() => el.classList.remove('shimmer'), 3000);
      // remove listener after first run
      window.removeEventListener('dh:signup-shimmer', handler);
    };
    window.addEventListener('dh:signup-shimmer', handler);
    return () => window.removeEventListener('dh:signup-shimmer', handler);
  }, []);

  // Close any open dropdowns on route changes
  useEffect(()=>{
    setMenuOpen(false);
  },[location.pathname]);

  return (
    <header className={`m-header ${compact ? 'compact' : ''}`} role="banner">
      <div className="m-header-left">
        <button className="m-logo-link" aria-label="DocuHounds home" onClick={()=>nav('/m')}>
          <img src="/logos/blue_gold_head.png" alt="DocuHounds home" className="m-header-icon" width="38" height="38" onError={(e)=>{e.target.style.display='none'}} />
          <span className="m-logo-text">DocuHounds</span>
        </button>
      </div>

      <div className="m-header-right">
        {token ? (
          <div className="m-user-wrap" ref={menuRef}>
            <button
              className="m-avatar-circle"
              style={{backgroundColor: avatarColor}}
              aria-haspopup="true"
              aria-expanded={menuOpen}
              onClick={()=>setMenuOpen(o=>!o)}
            >
              {initials}
            </button>
            {menuOpen && (
              <div className="m-user-menu" role="menu">
                <button className="m-user-menu-item" role="menuitem" onClick={()=>{nav('/profile'); setMenuOpen(false);}}>Profile</button>
                <button className="m-user-menu-item" role="menuitem" onClick={handleLogout}>Logout</button>
              </div>
            )}
          </div>
        ) : (
          <div className="m-actions">
            <button 
              onClick={(e) => {
                e.preventDefault();
                nav('/m/coming-soon');
              }}
              className="m-login-btn" 
              aria-label="Log in"
            >
              LOGIN
            </button>
            <button 
              id="mobile-header-signup" 
              onClick={(e) => {
                e.preventDefault();
                nav('/m/register');
              }}
              className="m-signup-btn" 
              aria-label="Sign up"
            >
              SIGN UP
            </button>
          </div>
        )}
      </div>
    </header>
  );
}
